import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { ITrayConfig } from "@miplatform/types";
import { toKebabCase } from "@miplatform/utils";
import { mdiChevronDown } from "@mdi/js";
import { Box, Fade, Typography } from "@mui/material";

export const TrayPreviewHeader: FC<TrayPreviewHeaderProps> = ({
  tray,
}: TrayPreviewHeaderProps) => {
  const { classes } = useStyles({ tray });

  return (
    <Box
      width="100%"
      data-testid={`${toKebabCase(tray.name)}-preview-header`}
      className={classes.root}
    >
      <Box className={classes.flexContainer}>
        <Box className={classes.countContainer}>
          <Typography className={classes.totalCountStyles} aria-hidden="true">
            2
          </Typography>
        </Box>

        <Typography className={classes.headerText}>{tray.name}</Typography>
      </Box>

      <Fade in={tray.collapsible}>
        <Box className={classes.flexContainer}>
          <MiIcon path={mdiChevronDown} color={tray.headerColor} size={0.8} />
        </Box>
      </Fade>
    </Box>
  );
};

interface TrayPreviewHeaderProps {
  tray: ITrayConfig;
}

const useStyles = makeStyles<{ tray: ITrayConfig }>()((theme, { tray }) => ({
  root: {
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
    backgroundColor: tray.headerBackgroundColor ?? theme.palette.primary.main,
    color: tray.headerColor ?? theme.palette.common.white,
    padding: theme.spacing(2, 3),
    borderBottom: `1px solid ${theme.palette.grey.accent}`,
    cursor: "default",
    transition: "background-color 0.3s ease",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  countContainer: {
    height: 18,
    width: 18,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: tray.countBackgroundColor ?? theme.palette.common.white,
    transition: "background-color 0.3s ease",
    borderRadius: "100%",
    marginRight: theme.spacing(1),
  },
  headerText: {
    color: tray.headerColor ?? theme.palette.common.white,
    fontSize: theme.fontSize.medium,
    fontWeight: theme.fontWeight.medium,
    transition: "color 0.3s ease",
  },
  totalCountStyles: {
    color: tray.countColor ?? theme.palette.common.white,
    fontSize: theme.fontSize.small,
    fontWeight: theme.fontWeight.bold,
    transition: "color 0.3s ease",
  },
}));
